import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Card } from '../../components/ui/card';
import { toast } from 'sonner';
import { Save, Mail, Phone, MessageCircle, Facebook, Instagram, Youtube, Info } from 'lucide-react';

const FIELDS = [
  { key: 'description', label: 'Description de la chaîne', textarea: true, icon: <Info size={16} /> },
  { key: 'email', label: 'Adresse email de contact', icon: <Mail size={16} />, placeholder: 'contact@gracetvgospel.top' },
  { key: 'phone', label: 'Téléphone', icon: <Phone size={16} />, placeholder: '+33 …' },
  { key: 'whatsapp', label: 'WhatsApp', icon: <MessageCircle size={16} />, placeholder: '+33 …' },
  { key: 'facebook_url', label: 'Facebook (URL)', icon: <Facebook size={16} />, placeholder: 'https://facebook.com/…' },
  { key: 'instagram_url', label: 'Instagram (URL)', icon: <Instagram size={16} />, placeholder: 'https://instagram.com/…' },
  { key: 'youtube_url', label: 'YouTube (URL)', icon: <Youtube size={16} />, placeholder: 'https://youtube.com/@…' },
  { key: 'credits', label: 'Crédits', textarea: true, icon: <Info size={16} />, placeholder: 'Réalisé par…' },
];

const blank = () => Object.fromEntries(FIELDS.map((f) => [f.key, '']));

const SettingsManager = ({ token }) => {
  const [settings, setSettings] = useState(blank());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((r) => {
        const next = blank();
        FIELDS.forEach((f) => {
          next[f.key] = r.data?.[f.key] || '';
        });
        setSettings(next);
      })
      .catch(() => toast.error('Échec du chargement des paramètres'));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.put(`${API}/settings`, settings, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Paramètres enregistrés');
    } catch {
      toast.error("Échec de l'enregistrement");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="resource-manager" data-testid="settings-manager">
      <Card className="add-video-card">
        <h3>Crédit & Contact — informations publiques</h3>
        <p className="tab-subtitle" style={{ marginBottom: '1.25rem' }}>
          Ces informations apparaîtront dans l'onglet "Crédit & Contact" du menu de la chaîne.
        </p>
        <form onSubmit={save} className="add-video-form">
          {FIELDS.map((f) => (
            <div key={f.key} className="settings-field">
              <label className="settings-label">
                {f.icon}
                <span>{f.label}</span>
              </label>
              {f.textarea ? (
                <textarea
                  className="bio-textarea"
                  rows={3}
                  placeholder={f.placeholder || ''}
                  value={settings[f.key] || ''}
                  onChange={(e) => setSettings({ ...settings, [f.key]: e.target.value })}
                  data-testid={`settings-${f.key}`}
                />
              ) : (
                <Input
                  placeholder={f.placeholder || ''}
                  value={settings[f.key] || ''}
                  onChange={(e) => setSettings({ ...settings, [f.key]: e.target.value })}
                  data-testid={`settings-${f.key}`}
                />
              )}
            </div>
          ))}
          <Button type="submit" disabled={loading} data-testid="save-settings-button">
            <Save size={16} />
            Enregistrer
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default SettingsManager;
